import { gql } from "@apollo/client";

export const TOUCHPOINTS_SUMMARY = gql`
  query GetTouchpointsSummary(
    $accountingMode: String!
    $attributionModel: String!
    $attributionWindow: String!
    $level: String!
    $timeGranularity: String!
    $dateRange: SalesDateRangeInput!
    $metricIds: [String!]!
    $dimensionIds: [String!]!
    $advancedSearch: JSONObject
    $breakdownFilters: [SalesTableReportV3BreakdownsFilterInput!]
    $campaignFilters: [String!]
    $adsetFilters: [String!]
    $adFilters: [String!]
    $metricFilters: [SalesMetricFilterInput!]
    $touchpointsSummaryDimensionIds: [String!]!
    $touchpointsSummaryRowFilter: JSONObject
  ) {
    me {
      touchpointsSummary(
        accountingMode: $accountingMode
        attributionModel: $attributionModel
        attributionWindow: $attributionWindow
        level: $level
        timeGranularity: $timeGranularity
        dateRange: $dateRange
        metricIds: $metricIds
        dimensionIds: $dimensionIds
        advancedSearch: $advancedSearch
        breakdownFilters: $breakdownFilters
        campaignFilters: $campaignFilters
        adsetFilters: $adsetFilters
        adFilters: $adFilters
        metricFilters: $metricFilters
        touchpointsSummaryDimensionIds: $touchpointsSummaryDimensionIds
        touchpointsSummaryRowFilter: $touchpointsSummaryRowFilter
      ) {
        data
        queryMetadata {
          bqLogs {
            query
            queryParameters
            queryTypes
            labels
            jobId
            queryId
            executionTimestamp
          }
        }
      }
    }
  }
`;
